import { animate, keyframes, style, transition, trigger } from '@angular/animations';
import { Component, Input } from '@angular/core';

type BannerType = 'info' | 'warning' | 'success' | 'error';

@Component({
  selector: 'gc-note-banner',
  templateUrl: './note-banner.component.html',
  styleUrls: ['./note-banner.component.scss'],
  animations: [
    trigger('bounceIn', [
      transition(':enter', [
        animate(
          '3000ms ease-out',
          keyframes([
            style({ transform: 'translateY(-100%)', offset: 0 }),
            style({ transform: 'translateY(30px)', offset: 0.3 }),
            style({ transform: 'translateY(-10px)', offset: 0.6 }),
            style({ transform: 'translateY(5px)', offset: 0.8 }),
            style({ transform: 'translateY(0)', offset: 1 }),
          ]),
        ),
      ]),
    ]),
  ],
  standalone: false,
})
export class NoteBannerComponent {
  @Input() noteText = '';
  @Input() noteTitle?: string;
  @Input() noteIcon: string = 'info';
  @Input() maxHeight: string = '100px';
  @Input() backgroundColor?: string;
  @Input() textColor?: string;
  @Input() type: BannerType = 'info';
  @Input() canClose: boolean = false;
  @Input() animation: boolean = false;
  @Input() hasBreadCrumb: boolean = false;

  closed = false;

  get bannerBg(): string {
    if (this.backgroundColor) return this.backgroundColor;
    switch (this.type) {
      case 'warning':
        return 'var(--warning-orange)';
      case 'success':
        return 'var(--success-green)';
      case 'error':
        return 'var(--error-red)';
      default:
        return 'var(--grey)';
    }
  }

  close(): void {
    this.closed = true;
  }
}
